/**
 * @description Displays the sync SSN field that indicates if the personnel records should be synced based on matching
 *  SSN values
 */

import React from 'react';
import { useFormContext, Controller, useWatch } from 'react-hook-form';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Switch from '@mui/material/Switch';
import { PropTypes } from 'prop-types';

const SsnSyncField = ({ onSyncOnSsnChange }) => {
  const { control } = useFormContext();
  const syncMap = useWatch({ name: 'syncMap' });
  const syncFile = useWatch({ name: 'syncFile' });

  // The ssn sync field should be hidden until the map is selected. Plus, this allows us to initialize
  // the checked state to the right state based on the syncMap's setting.
  if (!syncMap) {
    return null;
  }

  return (
    <Controller
      name='syncOnSsn'
      control={control}
      render={({ field: { onChange, value } }) => (
        <FormControl fullWidth>
          <FormControlLabel
            control={(
              <Switch
                onChange={(evt) => {
                  onChange(evt.target.checked)
                  onSyncOnSsnChange(syncFile, syncMap.name, evt.target.checked)
                }}
                checked={value}
              />
            )}
            label='Sync on SSN'
          />
          <FormHelperText>
            Syncs all personnel updates to any personnel with the same Social Security Number
          </FormHelperText>
        </FormControl>
      )}
    />
  )
};

SsnSyncField.propTypes = {
  onSyncOnSsnChange: PropTypes.func.isRequired
}

export default SsnSyncField;
